// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    organization: "Organization",
    description: "Your organization's name and web address",
    noAccess: "Only administrators can change the organization settings.",
    name: "Name",
    nameDescription:
      "Shown in the navigation, in e-mails and to clients in shared flows. Changes apply right away.",
    save: "Save",
    nameSaved: "Saved",
    error: "Error",
    failedToSave: "Failed to save the organization name",
    address: "Web address",
    addressDescription:
      "The address your users sign in on, also used in links sent to clients and in integrations.",
    copy: "Copy address",
    copied: "Address copied",
    changeAddress: "Change address",
    cooldown: (date: string) => `The address can be changed again on ${date}.`,
    notEditable: "This organization's name and address cannot be changed here.",
    reservedTitle: "Previous addresses",
    reservedItem: (address: string, date: string) => `${address} redirects here until ${date}`,
  },
  nb_NO: {
    settings: "Innstillinger",
    organization: "Organisasjon",
    description: "Organisasjonens navn og nettadresse",
    noAccess: "Bare administratorer kan endre organisasjonsinnstillingene.",
    name: "Navn",
    nameDescription:
      "Vises i navigasjonen, i e-poster og for kunder i delte flyter. Endringer gjelder med en gang.",
    save: "Lagre",
    nameSaved: "Lagret",
    error: "Feil",
    failedToSave: "Kunne ikke lagre organisasjonsnavnet",
    address: "Nettadresse",
    addressDescription:
      "Adressen brukerne logger inn på, og som brukes i lenker til kunder og i integrasjoner.",
    copy: "Kopier adresse",
    copied: "Adressen er kopiert",
    changeAddress: "Endre adresse",
    cooldown: (date: string) => `Adressen kan endres igjen ${date}.`,
    notEditable: "Denne organisasjonens navn og adresse kan ikke endres her.",
    reservedTitle: "Tidligere adresser",
    reservedItem: (address: string, date: string) => `${address} videresender hit til ${date}`,
  },
} as const;
